<h2 mat-dialog-title>
  Rammebeløb / Bevillingsrammer
  <mat-divider></mat-divider>
</h2>
@if (groups$ | async; as groups) {
  <mat-dialog-content>
    <p>Opsætning af bevillingsrammer for fonden. Bemærk, at bevillingsrammer <em>ikke</em> understøtter tillægsbevillinger.</p>
    <form [formGroup]="form">
      <div class="mb-2">
        <mat-checkbox ngDefaultControl  formControlName="no_exceeding_available">Overtræk på rammer IKKE tilladt.</mat-checkbox>
      </div>
      <div class="mb-2">
        <mat-checkbox ngDefaultControl  formControlName="least_one_source">Mindst en ramme pr sag</mat-checkbox>
      </div>
      <div class="mb-3">
        <mat-checkbox ngDefaultControl formControlName="multiple_sources">Tillad flere ramme pr sag</mat-checkbox>
      </div>
      <div class="mb-3">
        <mat-checkbox ngDefaultControl formControlName="allow_change_after_approval">Tillad ændring efter bevilling</mat-checkbox>
      </div>
      @if (groups.length > 0) {
        <mat-label>Dimensioner</mat-label>
        <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="30px">
          <mat-form-field>
            <mat-select [formControl]="groupSelector" placeholder="Vælg Ramme" style="min-width: 167px;">
              @for (group of groups; track group) {
                <mat-option
                  [value]="group.id"
                >{{group.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <button mat-icon-button (click)="addDimension()" [disabled]="!groupSelector.dirty">
            <mat-icon>add</mat-icon>
          </button>
        </div>
        @if (dimensionsChange$ | async) {
          @for (dimension of currentDimensions?.controls || []; track dimension; let i = $index) {
            <mat-card  class="forecast-dimension mb-3">
              <mat-card-content fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="50px">
                <mat-form-field class="forecast-dimension-input">
                  <mat-label>Navn</mat-label>
                  <input matInput [formControl]="dimension.controls.name">
                </mat-form-field>
                <mat-form-field class="forecast-dimension-input">
                  <mat-label>Kode</mat-label>
                  <input matInput [formControl]="dimension.controls.code">
                </mat-form-field>
                <button mat-icon-button (click)="removeDimension(i)">
                  <mat-icon>delete</mat-icon>
                </button>
              </mat-card-content>
            </mat-card>
          }
        }
      }
    </form>
  </mat-dialog-content>
}
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Luk</button>
  <button mat-flat-button (click)="doSave()">Gem</button>
</mat-dialog-actions>
